export const siteInformationData = {
  1: {
    id: 1,
    active: true,
    name: 'Viajes TDH',
    description: 'VIAJES TDH',
    email: 'reservas@viajestdh.com.ar',
    url: 'www.viajestdh.com.ar',
    emergency_phone: '0810-888-8448',
    short_name: 'TDH',
    address: 'Tucuman 303',
    country: 'Argentina',
    telephone: '3764',
    copyrights:
      '2008-[tag_año_actual]. ViajesTDH.com, de EPSYLON S.A., CUIT: 30-71040893-5, Empresa de Viajes y Turismo, Legajo: 13840. Todos los derechos reservados. 4 lugares disponibles por producto. Vigencia desde el [tag_fecha_vigencia]. LA AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.',
    copyrights_secondary: null,
    link_facebook: 'https://www.facebook.com/ViajesTDHoficial/',
    link_whatsapp: null,
    link_instagram: 'https://www.instagram.com/viajestdhoficial/',
    link_afip: 'https://qr.afip.gob.ar/?qr=NeJLDHSRTQso30EGlsY_oA,,',
    shared_url_title: null,
    plates_form_email: 'consultasweb@viajestdh.com.ar',
    legals: true,
    site_colors: {
      primary: '#F6D330',
      secondary: '#F6D330',
      tertiary: '#5725FF',
      lightGray: '#ededed',
      darkGray: '#c0c0c0',
      colorText1: '#000000',
      colorText2: '#000',
      headerColor: '#fff',
      footerColor: 'rgb(102, 102, 102)',
    },
    site_logos: {
      logo:
        'https://assets.conocecordoba.com.ar/voucher_hotels/nuevo-logo-tdh-horizontal.jpg',
      logo_vertical:
        'https://assets.conocecordoba.com.ar/voucher_hotels/Viajes-TDH-Logo-vertical.png',
      principal:
        'https://stg-assets.conocecordoba.com.ar/sites/stg_1/logo_1.svg%2Bxml',
      secondary: 'https://www.viajestdh.com.ar/assets/nuevoLogo.svg',
      footer:
        'https://assets.conocecordoba.com.ar/voucher_hotels/Viajes-TDH-Logo-vertical.png',
      login: 'https://assets.conocecordoba.com.ar/sites/prd_1/logo_7.png',
      main_loading_image:
        'https://assets.conocecordoba.com.ar/sites/prd_1/logo_12.gif',
      main_loading_image_fly:
        'https://assets.conocecordoba.com.ar/sites/prd_1/logo_14.gif',
      fifteenFooterLogo:
        'https://assets.conocecordoba.com.ar/sites/prd_1/logo_11.svg%2Bxml',
      main_loading_image_hot:
        'https://assets.conocecordoba.com.ar/sites/prd_1/logo_13.gif',
      logo_footer_email:
        'https://assets.conocecordoba.com.ar/voucher_hotels/Franquicias.jpg',
      fifteenNavLogo:
        'https://assets.conocecordoba.com.ar/sites/prd_1/logo_6.svg%2Bxml',
      logoAfip:
        'https://stg-assets.conocecordoba.com.ar/sites/stg_1/logo_17.jpeg',
      alt: 'https://assets.conocecordoba.com.ar/sites/prd_1/logo_3.png',
      map: 'https://assets.conocecordoba.com.ar/sites/prd_1/logo_4.png',
      favicon: 'https://dev-assets.viajestdh.com.ar/sites/dev_1/logo_18.x-icon',
    },
    site_functions: {
      showFranchise: true,
      showCompany: true,
      showWorkWithUs: true,
      showFifteen: true,
      showReservationButton: true,
      showPointsOfSale: true,
      showRegisterButton: true,
    },
    business_types: {
      id: 1,
      name: 'Business To Customer',
      code: 'BTC',
    },
    entity: {
      site_access_id: 1,
      site_access_id_site: 1,
      id_entity: 23,
      entity_name: 'Viajes TDH',
      status: 'active',
      access_user_id: 1,
      access_user_name: 'Admin',
      access_user_lastname: 'GIT',
      access_user_email: 'admin.git2@ross.com.ar',
      main_sellers: [],
      error_status: 200,
    },
  },
  2: {
    id: 2,
    active: true,
    name: 'Git',
    description: 'GIT OPERADOR',
    email: 'reservas@gitcordoba.com',
    url: 'www.gitcordoba.com',
    emergency_phone: '0810-888-8448',
    short_name: 'GIT',
    address: 'Tucumán 303, 1° piso',
    country: 'Córdoba, Argentina',
    telephone: '0810-888-8448',
    copyrights:
      '2001-[tag_año_actual] Todos los derechos reservados. Grupo de Inversiones Turísticas - GIT S.R.L. - Legajo: 11416 - CUIT Nº 30-70799318-5. La agencia de acceso a la información pública, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.',
    copyrights_secondary: null,
    link_facebook: 'https://www.facebook.com/GITCordoba',
    link_whatsapp: 'https://api.whatsapp.com/send?phone=5493517157094',
    link_instagram: 'https://www.instagram.com/gitoperador/',
    link_afip: 'https://qr.afip.gob.ar/?qr=NeJLDHSRTQso30EGlsY_oA,,',
    shared_url_title: null,
    plates_form_email: 'reservas@gitcordoba.com',
    site_colors: {
      primary: '#182A5E',
      colorText2: '#000',
      secondary: '#182A5E',
      headerColor: '#C2E6FA',
      tertiary: '#182A5E',
      footerColor: '#182A5E',
      lightGray: '#ededed',
      darkGray: '#c0c0c0',
      colorText1: '#fff',
    },
    site_logos: {
      logo: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_1',
      principal:
        'https://assets.conocecordoba.com.ar/sites/prd_2/logo_1.svg%2Bxml',
      secondary: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_2',
      footer: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_2',
      login: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_7',
      logo_email_header:
        'https://tst-assets.viajestdh.com.ar/sites/tst_2/logo_15.png',
      main_loading_image_hot:
        'https://assets.conocecordoba.com.ar/sites/prd_2/logo_13.gif',
      main_loading_image:
        'https://assets.conocecordoba.com.ar/sites/prd_2/logo_12.gif',
      main_loading_image_fly:
        'https://assets.conocecordoba.com.ar/sites/prd_2/logo_14.gif',
      logo_footer_email:
        'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_1',
      logoAfip:
        'https://stg-assets.conocecordoba.com.ar/sites/stg_2/logo_17.jpeg',
      alt: 'https://assets.conocecordoba.com.ar/sites/prd_2/logo_3.svg%2Bxml',
      map: 'https://assets.conocecordoba.com.ar/sites/prd_2/logo_4.svg%2Bxml',
      fifteenNavLogo:
        'https://assets.conocecordoba.com.ar/sites/prd_2/logo_6.svg%2Bxml',
      logo_vertical: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_1',
      favicon: 'https://dev-assets.viajestdh.com.ar/sites/dev_2/logo_18.x-icon',
    },
    site_functions: {
      onlyUsersLogged: true,
      showCompany: true,
      pagePackage: true,
      showDollarInfo: true,
      showPaymentMethods: true,
      showReservationButton: true,
      showContact: true,
      searchCards: true,
      userRegister: true,
      showRegisterButton: true,
      showFifteen: false,
    },
    business_types: {
      id: 2,
      name: 'Business To Business',
      code: 'BTB',
    },
    entity: {
      site_access_id: 2,
      site_access_id_site: 2,
      id_entity: 46,
      entity_name: 'GIT Central',
      status: 'active',
      access_user_id: 135,
      access_user_name: 'GIT Admin',
      access_user_lastname: 'Site',
      access_user_email: 'admin.git@gitcordoba.com',
      main_sellers: [
        {
          id_user: 975,
          is_main_seller: 1,
          name: 'Romina',
          last_name: 'Banegas',
          email: 'romina.banegas@gitcordoba.com',
        },
        {
          id_user: 290,
          is_main_seller: 1,
          name: 'Carolina',
          last_name: 'Vivas',
          email: 'carolina.vivas@gitcordoba.com',
        },
        {
          id_user: 292,
          is_main_seller: 1,
          name: 'Antonella',
          last_name: 'Gasparini',
          email: 'antonella.gasparini@gitcordoba.com',
        },
        {
          id_user: 295,
          is_main_seller: 1,
          name: 'Gabriela',
          last_name: 'Ludueña',
          email: 'gabriela.luduena@gitcordoba.com',
        },
        {
          id_user: 792,
          is_main_seller: 1,
          name: 'Debora',
          last_name: 'Deisel',
          email: 'debora.deisel@gitcordoba.com',
        },
        {
          id_user: 1050,
          is_main_seller: 1,
          name: 'Romina',
          last_name: 'Salgado',
          email: 'romisalgado28@gmail.com',
        },
      ],
      error_status: 200,
    },
  },
};
